import React from "react";
import { isSet } from "../../../../../../utils/commonUtils";

const LabelField = ({col,label,fontBold,isBold,appendClass,border,displayValue,displayName,appendClassLabel='',formData,labelStyle})=>{
    const column = isSet(col,'col-12');
    const fontWeight = (isBold===true)?'font-weight-bold':'';
    const borderCls = (border===true)?'border border-left-0':'';
    const value = displayValue && displayName && formData ? isSet(formData[displayName], '--') : '';
    // const labelOpacityCls = labelStyle && (labelStyle.color || labelStyle.opacity !== undefined) ? 'opacity-100' : 'opacity-75';
    
    return(
        <div className={`${column} ${borderCls}  py-1 ${appendClass}`} >
            <label className={`${fontWeight} f-${fontBold} ${appendClassLabel} mb-0 `} title={label} style={labelStyle}>  {label}  </label>
            {displayValue && value && (
                <h6 className="font-weight-bold text-sm text-truncate mb-0 mt-1">
                    {value}
                </h6>
            )}
        </div>
    )
}
LabelField.defaultProps = {
    col:'col-12',
    appendClass:'',
    fontBold:'400',
    isBold:true,
    border:true,
    displayValue:false,
    displayName:'',
    formData:{}
}
export default LabelField;